module.exports = __webpack_public_path__ + "static/img/hzhb5.9a5f5fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hzhb5.png
// module id = nadZ
// module chunks = 0